import type { ReactNode } from 'react';
import { useTranslations } from 'next-intl';

export function Mention({ children }: { children?: ReactNode }) {
  const t = useTranslations('home.discord');
  return <span className="mention">{children ?? t('mention')}</span>;
}
